import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { Provider as ReduxProvider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import ReactModal from 'react-modal'
import { TranslationContainer } from 'react-i18n-lite'
import { ThemeProvider } from 'styled-components'
import { defaultTheme, YesErrorTracking } from '@yes.technology/react-toolkit'

import store, { persistor } from './state/store'
import HelloYes from './modules/shared/HelloYes'
import apiAsync from './utils/api-async'
import { configStatus } from './utils/configStatus'
import ResizeDetector from './modules/shared/ResizeDetector'
import locales, { defaultLanguage } from './modules/shared/I18n'
import { AuthenticationProvider } from 'authentication'
import apiUtils from 'utils/api'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import sanitizeSW from 'sanitizeServiceWorker'
import * as googleTagManager from './modules/shared/GTM'

YesErrorTracking({
  service: 'sentry',
  publicKey: window.sentryDNS,
  traceTargets: window.trackingUrls
})

// TODO: Check if this require is really necessary
// eslint-disable-next-line @typescript-eslint/no-var-requires
window.Buffer = require('buffer/').Buffer

ReactModal.setAppElement('#root')

/* Initialize Google Tag Manager */
googleTagManager.initialize(window.googleTagManagerArgs)

configStatus(window)
apiAsync.setConfig(window.msApi || {})
apiAsync.setDispatch(store.dispatch)
apiUtils.setDispatch(store.dispatch)

const prepare = async () => {
  if (
    process.env.NODE_ENV === 'development' &&
    window.location.hostname === 'localhost'
  ) {
    const { default: worker } = await import('./api/mocks/serviceWorker')
    return worker.start({
      onUnhandledRequest: 'bypass',
      serviceWorker: {
        url: '/mockServiceWorker.js'
      }
    })
  }

  return Promise.resolve()
}

const container = document.getElementById('root')
const root = createRoot(container as HTMLElement)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
})

const router = createBrowserRouter([
  {
    path: '*',
    element: <HelloYes />
  }
])

prepare()
  .then(() =>
    root.render(
      <ThemeProvider theme={defaultTheme}>
        <ReduxProvider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <QueryClientProvider client={queryClient}>
              <TranslationContainer
                defaultLanguage={defaultLanguage}
                locales={locales}
              >
                <AuthenticationProvider>
                  <ResizeDetector>
                    <RouterProvider router={router} />
                  </ResizeDetector>
                </AuthenticationProvider>
              </TranslationContainer>
            </QueryClientProvider>
          </PersistGate>
        </ReduxProvider>
      </ThemeProvider>
    )
  )
  .catch(console.error)

// registerServiceWorker()
sanitizeSW()
